import React from 'react';
import { Tooltip } from '@mui/material';

export function productDisplayName(displayName?: string | null, productId?: string | null): string {
  const name = (displayName ?? '').trim();
  if (name) return name;
  return (productId ?? '').trim() || 'Produto';
}

type ProductOptionLabelProps = {
  displayName?: string | null | undefined;
  productId: string;
  /** Quando false, não exibe tooltip (ex.: opção vazia do select). */
  showIdOnHover?: boolean;
};

/** Nome do produto visível; ID apenas no tooltip ao passar o mouse. */
export const ProductOptionLabel: React.FC<ProductOptionLabelProps> = ({
  displayName,
  productId,
  showIdOnHover = true
}) => {
  const name = productDisplayName(displayName, productId);
  if (!showIdOnHover || !productId.trim()) {
    return <span>{name}</span>;
  }

  return (
    <Tooltip title={productId} arrow placement="top" enterDelay={300}>
      <span style={{ display: 'inline-block', maxWidth: '100%' }}>{name}</span>
    </Tooltip>
  );
};
